export const createSpeedLimitCertificateService = (fetch) => async (data) => {
  try {
    const response = await fetch({
      url: "/api/v1/funcionamiento/certificado-limite-velocidad",
      method: "post",
      body: data,
      contentType: "multipart/form-data",
    });

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
};
